import PropTypes from "prop-types";
import { Navigate } from "react-router-dom";
import { isTokenExpired } from "api/Api";

const hasPermission = (userPermissions, required) => {
  if (!required) return true;
  if (!userPermissions || !Array.isArray(userPermissions)) return false;
  if (userPermissions.includes(required)) return true;

  const alternates = [];
  if (required.startsWith("manage_")) {
    const base = required.replace("manage_", "");
    alternates.push(`view_${base}`, `add_${base}`, `edit_${base}`);
  } else if (required.startsWith("view_")) {
    const base = required.replace("view_", "");
    alternates.push(`manage_${base}`, `add_${base}`, `edit_${base}`);
  } else if (required.startsWith("add_")) {
    const base = required.replace("add_", "");
    alternates.push(`manage_${base}`, `view_${base}`, `edit_${base}`);
  }

  return alternates.some((alt) => userPermissions.includes(alt));
};

export default function ProtectedRoute({ children, requiredPermission }) {
  const token = localStorage.getItem("token");
  const permissions = JSON.parse(localStorage.getItem("permissions")) || [];
  const role = localStorage.getItem("role");

  if (!token || isTokenExpired(token)) {
    localStorage.clear();
    return <Navigate to="/authentication/sign-in" replace />;
  }

  // Check if role is a valid admin panel role
  const allowedAdminRoles = ["Super_Admin", "Admin", "Leader", "Worker"];
  if (!role || !allowedAdminRoles.includes(role)) {
    return <Navigate to="/authentication/sign-in" replace />;
  }

  // Permission check dynamically evaluated against user's permissions array
  if (requiredPermission && !hasPermission(permissions, requiredPermission)) {
    if (requiredPermission === "view_dashboard") {
      return <Navigate to="/authentication/sign-in" replace />;
    }
    return <Navigate to="/dashboard" replace />;
  }

  return children;
}

ProtectedRoute.propTypes = {
  children: PropTypes.node.isRequired,
  requiredPermission: PropTypes.string,
};
